
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { Client } from "@/types";
import { useClientForm } from "@/hooks/useClientForm";
import { ClientInfoDisplay } from "./personal-info/ClientInfoDisplay";
import { ClientInfoForm } from "./personal-info/ClientInfoForm";
import { ClientInfoActions } from "./personal-info/ClientInfoActions";
import { ClientInfoEmpty } from "./personal-info/ClientInfoEmpty";

interface ClientPersonalInfoSectionProps {
  client: Client;
}

export const ClientPersonalInfoSection = ({ client }: ClientPersonalInfoSectionProps) => {
  const {
    isEditing,
    isSaving,
    formData,
    setIsEditing,
    handleChange,
    handleSelectChange,
    handleSave,
    handleCancel
  } = useClientForm(client);

  // Check if the client has REAL personal information (not just tier)
  const hasDetailedPersonalInfo = client.email || client.phone || client.age || client.gender || client.goals;

  return (
    <Card className="backdrop-blur-lg bg-white/10 border-white/20 h-full">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-white">Personal Information</CardTitle>
        <ClientInfoActions
          isEditing={isEditing}
          isSaving={isSaving}
          onEdit={() => setIsEditing(true)}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </CardHeader>
      <CardContent>
        {hasDetailedPersonalInfo ? (
          isEditing ? (
            <ClientInfoForm
              formData={formData}
              handleChange={handleChange}
              handleSelectChange={handleSelectChange}
            />
          ) : (
            <ClientInfoDisplay client={client} />
          )
        ) : (
          <ClientInfoEmpty />
        )}
      </CardContent>
    </Card>
  );
};
